import application from 'application/application';

import template from './inss-manager.template.html';
import controller from './inss-manager.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.inssManager', {
			url: '/inss/acessos?paginaAtual',
			views: {
				'default@root.default': {
					templateUrl: template,
					controller
				}
			},
			data: {
				documentTitle: 'INSS'
			}
		});
	}
]);
